import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { DraggablemodalComponent } from '../draggablemodal/draggablemodal.component';

@Component({
  selector: 'app-vehicle',
  templateUrl: './vehicle.component.html',
  styleUrls: ['./vehicle.component.scss']
})
export class VehicleComponent implements OnInit {

  public dateAsObject = '';
  public showTitle: boolean = true;
  public isShow: boolean = true;
  public isShow1: boolean = false;
  public isShow2: boolean = false;
  public isShow3: boolean = false;
  public isShow4: boolean = false;
  public isShow6: boolean = false;
  public isShow7: boolean = false;
  public isShow8: boolean = false;
  public isShow9: boolean = false;
  public vindetail: any = [];
  public regdetail: any = [];
  public vin: any;
  public tokenDetails: any;
  public selectedRegistration: any = [];
  public year: any;
  public month: any;
  public day: any;
  public setflagforlist: boolean = false;
  public isBackToTopShowBtn: boolean = false;
  public invinnumber: any;
  public inregnumber: any;
  public errormsg: any = '';
  public errormsg_reg: any = '';
  public vinLookUp: any;
  public regLookUp: any;
  public vehicle: boolean = false;
  public flag: boolean = false;
  public noregis: boolean = false;
  public userId: any
  public Vinnumber: any;
  public availableVins: any = [];
  public regdetailnew: any = [];
  public regilast: any;
  public datelast: any;
  public countrylast: any;
  public createtimelast: any;
  public countrypresent: boolean = false
  public getvin = false;
  public userType: any;
  public countryCode = ['GBR', 'ESP', 'NLD', 'ITA', 'PRT', 'SWE', 'DNK', 'NOR', 'FIN', 'HUN', 'IRL'];
  public showSBDAdminTab:boolean=false;
  public globalManagedRes:any;
  public globalServices:any =[];
 targetEngineServiceResponseObj:any
 idsFdspEngineServiceResponseObj:any
 ptsEngineServiceResponseObj:any
 fdspEngineServiceResponseObj:any
 isEnableService=false
  constructor(
    private modalService: NgbModal,private translate: TranslateService, private service: ApifirstService,
    @Inject(DOCUMENT) private document: Document, private router: Router
  ) { }
  ngOnInit(): void {
    this.service.serviceNameListservice.subscribe((data) =>{
      this.globalServices=data
      for (let obj of this.globalServices){
        if (obj.serviceName=="PTS Service"){
          this.ptsEngineServiceResponseObj=obj;
        }
        if (obj.serviceName=="FDSP Service"){
          this.fdspEngineServiceResponseObj=obj;
        }
      }
      
    })
    this.service.showSBDAdminTab.subscribe((data) => {
      this.showSBDAdminTab = data
    })
    this.service.tokenObj.subscribe((data) => {
      this.tokenDetails = data
    })
    
    this.service.tokenVinNum.subscribe((data) => {
      this.Vinnumber = data
    })
    this.countrypresent = this.countryCode.includes(this.tokenDetails.countryThree);
    this.userType = this.tokenDetails.userType
    // if (this.userType == "ADMIN") {
       this.getvin = true
    // }
    // else {
    //  this.getvin = false
    //}
  }
  /** start diagnosis button**/
  onButtonGroupClick($event: any) {
    this.showTitle = false;
    let clickedElement = $event.target || $event.srcElement;
    if (clickedElement.nodeName === "BUTTON") {
      let isCertainButtonAlreadyActive = clickedElement.parentElement.querySelector(".active");
      if (isCertainButtonAlreadyActive) {
        isCertainButtonAlreadyActive.classList.remove("active");
      }
      else {
        clickedElement.className += " active";
      }
    }
  }
  /** to open pop up **/
  openModal() {
    
    this.service.userId.subscribe((data) => {
      this.userId = data
    })
    const req = {
      "userId": this.userId,
      "sessionSource": "gfdrs",
      "vin": this.Vinnumber
    }
    this.service.createSession(req).subscribe((data: any) => {
      localStorage.setItem("sessionID", data)
    })
    const modalRef = this.modalService.open(DraggablemodalComponent, {
      windowClass: "myCustomModalClass"
    });
    modalRef.result.then(
      result => {
        console.log(result);
      },
      reason => { }
    );
  }
  /** to get the vehicle name when searched by VIN number**/
  vindetailsApi() {
    /*reset all the values**/
    this.clearVariables();

    const pattern = new RegExp('^(?:(?![IOQioq])[A-Za-z0-9])+$');
    /** validate the input vin number */
    if ((this.invinnumber == null || this.invinnumber == undefined || this.invinnumber == '' ||
      this.invinnumber.length === 0)) {
      this.errormsg =this.translate.instant('Please supply a VIN Number')
      this.vehicle = false;
      this.flag = true;
    }
    else if (this.invinnumber.length < 17 && this.invinnumber.length !== 0) {
      this.errormsg =this.translate.instant('VINs should be 17 characters long');
      this.vehicle = false;
      this.flag = true;
    }
    else if (!pattern.test(this.invinnumber)) {
      this.errormsg = this.translate.instant('VIN validation');
      this.vehicle = false;
      this.flag = true;
    }
    else {
      this.errormsg = '';
      this.vinLookUp = this.invinnumber;
    }
    const vin = {
      "vin": this.vinLookUp,
      "paCode": this.tokenDetails.dealerCode,
      "country": this.tokenDetails.countryThree,
      "language": this.tokenDetails.language
    }
    this.service.getGlobalManagedServicesDetails(this.ptsEngineServiceResponseObj.id).subscribe((data) => {
      this.globalManagedRes=data;
      if (!this.globalManagedRes){
        this.isEnableService =true;
     } else {
         this.isEnableService =false;
     }

     if(this.isEnableService) {
      this.service.getVindetails(vin).subscribe(
        (data) => {
          this.vindetail = data
          /*to validate whether the vin number given by user is our table*/
          if ((this.vindetail.vehicleLineDescription == "" &&
            this.vindetail.engineDescription == "" &&
            this.vindetail.paintDescription == "" &&
            this.vindetail.vin != "")) {
            this.vehicle = false;
            this.errormsg = "We are sorry, but no information could be found for the VIN you entered -" + this.vinLookUp;
          }
          else {
            if (this.flag == false) {
              this.vehicle = true;
              this.tokenDetails.vin = this.vindetail.vin;
              this.service.tokenVinNum.next(this.tokenDetails.vin)
            }
          }
        },
        (err) => {
          /* if we get the response as error */
          if (this.vinLookUp != '') {
            this.errormsg = "We are sorry, but no information could be found for the VIN you entered -" + this.vinLookUp;
            this.vehicle = false;
          }
        })
     } else {
      this.service.selectedGlobalServices.next('PTS Engine Service')
      this.router.navigate(['/globalServiceEnabled']);
     }
    });
   
  }
  /** to get the vehicle details when searched by VIN number**/
  getRegdetails() {
    const vin = {
      "vin": this.vinLookUp,
      "paCode": this.tokenDetails.dealerCode,
      "country": this.tokenDetails.country,
      "language": this.tokenDetails.language
    }
    this.service.getGlobalManagedServicesDetails(this.fdspEngineServiceResponseObj.id).subscribe((data) => {
      this.globalManagedRes=data;
      if (!this.globalManagedRes){
        this.isEnableService =true;
     } else {
         this.isEnableService =false;
     }

     if (this.isEnableService){
      this.service.getRegdetails(vin).subscribe(
        (data1) => {
          this.regdetail = data1
          if (this.regdetail.length > 0) {
            this.noregis = true
          }
          else {
            this.noregis = false
          }
          if (this.regdetail.length > 1) {
            this.setflagforlist = true;
          }
          else {
            this.setflagforlist = false;
          }
          for (let i in this.regdetail) {
            if (this.regdetail[i].vin == this.vinLookUp) {
              this.selectedRegistration = this.regdetail[0];
              if (this.selectedRegistration.dateAsObject == null) {
                this.dateAsObject = '';
              }
              else if (this.selectedRegistration.date == null) {
                this.year = '';
                this.month = '';
                this.day = '';
              }
              else {
                this.dateAsObject = this.selectedRegistration.dateAsObject.split("T", 1)
                this.year = this.selectedRegistration.date.substr(0, 4);
                this.month = this.selectedRegistration.date.substr(4, 2);
                this.day = this.selectedRegistration.date.substr(6, 2);
              }
              this.dateAsObject = this.selectedRegistration.dateAsObject.split("T", 1)
              this.year = this.selectedRegistration.date.substr(0, 4);
              this.month = this.selectedRegistration.date.substr(4, 2);
              this.day = this.selectedRegistration.date.substr(6, 2);
            }
          }
        },
        (err) => {
        }
      )
     } else {
      this.service.selectedGlobalServices.next('FDSP Engine Service')
      this.router.navigate(['/globalServiceEnabled']);
     }
    });
  
  }
  /** to get the vehicle name when searched by Registration number**/
  fetchVinNumber(selectVinPopup: any) {
    /*reset all the values**/
    this.clearVariables();

    if ((this.inregnumber == null || this.inregnumber == undefined || this.inregnumber == '' ||
      this.inregnumber === 0)) {
      this.errormsg_reg = "Please supply a Registration Number.";
      this.vehicle = false
    }
    else {
      this.errormsg_reg = '';
      this.regLookUp = this.inregnumber;
    }
    const reg = {
      "registration": this.regLookUp,
      "paCode": this.tokenDetails.dealerCode,
      "language": this.tokenDetails.language,
      "country": this.tokenDetails.country
    }
    this.service.getGlobalManagedServicesDetails(this.fdspEngineServiceResponseObj.id).subscribe((data) => {
      this.globalManagedRes=data;
      if (!this.globalManagedRes){
        this.isEnableService =true;
     } else {
         this.isEnableService =false;
     }

     if (this.isEnableService) {
      this.service.fetchVin(reg).subscribe(
        (data) => {
          this.displayVin(data, selectVinPopup);
        },
        (err) => {
          if (this.regLookUp != '') {
            this.errormsg_reg = "We are sorry, but no information could be found for the Registration number you entered -" + this.regLookUp;
            this.vehicle = false;
          }
        }
      );
     } else {
      this.service.selectedGlobalServices.next('FDSP Engine Service')
      this.router.navigate(['/globalServiceEnabled']);
     }
    });
  
  }
  displayVin(vinList: any, selectVinPopup: any) {
    if (vinList.length > 1) {
      this.availableVins = vinList.slice(0, 5);
      this.modalService.open(selectVinPopup, { size: 'lg' });
    }
    else {
      this.handleData(vinList[0].vin);
    }
  }
  passSelectedVin(vin: any) {
    this.handleData(vin);
  }
  handleData(data: any) {
    const fetchedVin = data;
    var req = {
      "vin": fetchedVin,
      "paCode": this.tokenDetails.dealerCode,
      "country": this.tokenDetails.countryThree,
      "language": this.tokenDetails.language
    }
    this.service.getGlobalManagedServicesDetails(this.fdspEngineServiceResponseObj.id).subscribe((data) => {
      this.globalManagedRes=data;
      if (!this.globalManagedRes){
        this.isEnableService =true;
     } else {
         this.isEnableService =false;
     }

     if (this.isEnableService){
      this.service.getVindetails(req).subscribe(
        (data: any) => {
          this.tokenDetails.vin = fetchedVin
          this.service.tokenVinNum.next(this.tokenDetails.vin)
          this.vindetail = data
          this.errormsg_reg = '';
          this.vehicle = true
        }, (err) => {
          this.errormsg_reg = "We are sorry, but no information could be found for the Registration number you entered -" + this.regLookUp;
        });
     } else {
      this.service.selectedGlobalServices.next('FDSP Engine Service')
      this.router.navigate(['/globalServiceEnabled']);
     }
    });
   
    const regis = {
      "vin": fetchedVin,
      "paCode": this.tokenDetails.dealerCode,
      "country": this.tokenDetails.country,
      "language": this.tokenDetails.language
    }
    /* to get the Reg details of the associated VIN number to the registration number searched*/
    this.service.getRegdetails(regis).subscribe(
      (data1) => {
        this.regdetail = data1
        if (this.regdetail.length > 0) {
          this.noregis = true
        }
        else {
          this.noregis = false
        }
        if (this.regdetail.length > 1) {
          this.setflagforlist = true;
        }
        else {
          this.setflagforlist = false;
        }
        for (let i in this.regdetail) {
          if (this.regdetail[i].vin == fetchedVin) {
            this.selectedRegistration = this.regdetail[0];
            if (this.selectedRegistration.dateAsObject == null) {
              this.dateAsObject = '';
            }
            else if (this.selectedRegistration.date == null) {
              this.year = '';
              this.month = '';
              this.day = '';
            }
            else {
              this.dateAsObject = this.selectedRegistration.dateAsObject.split("T", 1)
              this.year = this.selectedRegistration.date.substr(0, 4);
              this.month = this.selectedRegistration.date.substr(4, 2);
              this.day = this.selectedRegistration.date.substr(6, 2);
            }
          }
        }
      })
  }
  /** pop up which has list of registration numbers **/
  listofregistration(contentRegPopup: any) {
    this.regilast = this.regdetail[this.regdetail.length - 1].registration;
    this.datelast = this.regdetail[this.regdetail.length - 1].dateAsObject;
    this.countrylast = this.regdetail[this.regdetail.length - 1].country;
    this.createtimelast = this.regdetail[this.regdetail.length - 1].createTime;

    this.modalService.open(contentRegPopup, {});
  }

  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }
  /* for window scroll up */
  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }
  /*to open customer consent*/
  openModal1(longcontent: any) {
    this.modalService.open(longcontent, { centered: true });
  }
  /*to open the FDRS check pop up*/
  openModal2(fdrscontent: any) {
    this.modalService.open(fdrscontent, { centered: true });
  }
  /*for future use*/
  openModal3() { }
  clearVariables() {
    this.vindetail = [];
    this.regdetail = [];
    this.day = '';
    this.year = '';
    this.month = '';
    this.dateAsObject = '';
    this.vehicle = false;
    this.regLookUp = ''
    this.errormsg_reg = '';
    this.errormsg = '';
    this.selectedRegistration = [];
    this.noregis = false
    this.setflagforlist = false
    this.vinLookUp = '';
    this.flag = false;
  }
}

